export const GET_STATUS_DATA_REQUEST = "GET_STATUS_DATA_REQUEST";
export const GET_STATUS_DATA_SUCCESS = "GET_STATUS_DATA_SUCCESS";
export const GET_STATUS_DATA_FAILURE = "GET_STATUS_DATA_FAILURE";

export const UPDATE_STATUS_REQUEST = "UPDATE_STATUS_REQUEST";
export const UPDATE_STATUS_SUCCESS = "UPDATE_STATUS_SUCCESS";
export const UPDATE_STATUS_FAILURE = "UPDATE_STATUS_FAILURE";

export const POST_STATUS_REQUEST = "POST_STATUS_REQUEST";
export const POST_STATUS_SUCCESS = "POST_STATUS_SUCCESS";
export const POST_STATUS_FAILURE = "POST_STATUS_FAILURE";

export const UPDATE_STATUS_ENTITY_PARAMS_SUCCESS = "UPDATE_STATUS_ENTITY_PARAMS_SUCCESS";
export const UPDATE_STATUS_ENTITY_PARAMS_FAILURE = "UPDATE_STATUS_ENTITY_PARAMS_FAILURE";

export const STATUS_DROPDOWN_REQUEST = "STATUS_DROPDOWN_REQUEST";
export const STATUS_DROPDOWN_SUCCESS = "STATUS_DROPDOWN_SUCCESS";
export const STATUS_DROPDOWN_FAILURE = "STATUS_DROPDOWN_FAILURE";

export const RESTORE_STATUS_LOG_REQUEST = "RESTORE_STATUS_LOG_REQUEST";
export const RESTORE_STATUS_LOG_SUCCESS = "RESTORE_STATUS_LOG_SUCCESS";
export const RESTORE_STATUS_LOG_FAILURE = "RESTORE_STATUS_LOG_FAILURE";

export const DELETE_STATUS_REQUEST = "DELETE_STATUS_REQUEST";
export const DELETE_STATUS_SUCCESS = "DELETE_STATUS_SUCCESS";
export const DELETE_STATUS_FAILURE = "DELETE_STATUS_FAILURE";
